import capRegistrationActions from "./actions";

const initialState = {
  capDocuments: [],
  capCandidatures:[],
  capCategories:[],
  capCourseList:[]
};

const capReducer = (state = initialState, action) => {
  switch (action.type) {
    case capRegistrationActions.SET_CAP_COURSE_DOCUMENT:
      return {
        ...state,
        capDocuments: action.payload
      };
    case capRegistrationActions.SET_CAP_CANDIDATURE:
        return {
          ...state,
          capCandidatures: action.payload
        };
    case capRegistrationActions.SET_CAP_CATEGORY:
          return {
            ...state,
            capCategories: action.payload
          };
    case capRegistrationActions.SET_ALL_CAP_COURSE:
        return {
          ...state,
          capCourseList: action.payload
        };
 
    

    default:
      return state;
  }
};

export default capReducer;